import React from 'react'
import { useHashParams } from '../hooks/useHashParams'
import TroubleInstallingModal from './TroubleInstallingModal'
import { WhereIsTheProductNameModal } from './WhereIsTheProductNameModal'
import { ScanningFeaturesNoticeModal } from './ScanningFeaturesNoticeModal'
import { SwitchToAMobileDeviceModalGeneral } from './SwitchToAMobileDeviceModalGeneral'
import { SwitchToAMobileDeviceModalCompatibility } from './SwitchToAMobileDeviceModalCompatibility'
import { AlignmentHelpModal } from './AlignmentHelpModal'

const ModalList = {
  '#trouble-installing': TroubleInstallingModal,
  '#trouble-installing-hp-app': TroubleInstallingModal,
  '#wheres-the-product-name': WhereIsTheProductNameModal,
  '#scanning-features-notice': ScanningFeaturesNoticeModal,
  '#switch_mobile_device_compatibility':
    SwitchToAMobileDeviceModalCompatibility,
  '#switch_mobile_device': SwitchToAMobileDeviceModalGeneral,
  '#alignment-help': AlignmentHelpModal
}

export const AllModals = () => {
  const hashParams = useHashParams()

  const ModalComponent = ModalList?.[hashParams.param]

  if (!ModalComponent) {
    return <></>
  }

  return (
    <div style={{ position: 'relative' }}>
      <ModalComponent
        open={true}
        onClose={() => {
          hashParams.clear()
        }}
      />
    </div>
  )
}
